// 泰语
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "ประวัติ",
    emptyRecords: "ยังไม่มีประวัติรูเล็ตผลไม้",
    guessResult: "ผลการทาย",
    myGuesses: "การทายของฉัน",
    guessFailed: "ทายไม่ถูก",
    winningPlayers: "ผู้เล่นที่ชนะ",
    noGuesses: "คุณไม่ได้ทายในรอบนี้",
    noWinners: "ไม่มีผู้เล่นที่ชนะในรอบนี้",
    rulesTitle: "วิธีเล่น",
    rulesDescription: "แต่ละรอบมีเวลา 50 วินาทีให้ทายผลไม้ที่จะออก หากทายถูกจะได้รับรางวัลน้ำค้างตามผลไม้นั้น",
    guessingTitle: "วิธีทาย",
    guessingDescription: "ภายในเวลาทาย เลือกจำนวนน้ำค้างที่ต้องการเดิมพัน แล้วแตะพื้นที่เดิมพันของผลไม้บนหน้าจอเพื่อทาย",
    rewardsTitle: "รางวัล",
    rewardsDescription: "ผลไม้แต่ละชนิดให้รางวัลน้ำค้างแตกต่างกัน",
    fruit: "ผลไม้",
    multiplier: "ตัวคูณรางวัล",
    apple: "แอปเปิล",
    watermelon: "แตงโม",
    orange: "ส้ม",
    banana: "กล้วย",
    grape: "องุ่น",
  },
  setPresident: {
    intro: "คุณสามารถแต่งตั้งประธานเพื่อช่วยดูแลคลับของคุณได้",
    selfIntro: "คุณคือประธานคลับ",
    president: "ประธาน",
    empty: "ยังไม่ได้แต่งตั้งประธาน",
    appoint: "แต่งตั้ง",
    privileges: "สิทธิ์ของประธาน",
    privilegesIntro: "ประธานมีสิทธิ์ดังต่อไปนี้",
    title: "แต่งตั้งประธาน",
    selectMember: "เลือกสมาชิกที่ต้องการแต่งตั้งเป็นประธาน",
    member: "สมาชิก",
    attendance: "เข้าร่วม {days} วัน",
    weekContribution: "ผลงานชื่อเสียง (สัปดาห์):",
    monthContribution: "(เดือน):",
    confirmAppoint: "แต่งตั้งสมาชิกนี้เป็นประธานหรือไม่?",
    confirm: "ยืนยัน",
    remove: "ปลดจากตำแหน่ง",
    cancel: "ยกเลิก",
    removeTitle: "ปลดประธานคลับ",
    confirmRemove: "ยืนยันการปลด {name} จากตำแหน่งประธานคลับหรือไม่?",
    unnamed: "ไม่มีชื่อ",
    pkTitle: "ห้อง PK",
    pkDesc: "ประธานสามารถเปิด ปิด และจัดการห้อง PK ของคลับได้",
    infoTitle: "ข้อมูลคลับ",
    infoDesc: "ประธานและเจ้าของคลับสามารถแก้ไขภาพปก ชื่อ คำประกาศ และข้อมูลอื่น ๆ ของคลับได้",
    membersTitle: "การจัดการสมาชิก",
    membersDesc: "ประธานและเจ้าของคลับสามารถนำสมาชิกและแขกออกจากคลับได้",
    rewardsTitle: "รางวัลคลับ",
    rewardsDesc: "ประธานสามารถรับรางวัลของคลับได้ หากยังไม่ได้แต่งตั้งประธาน จะไม่สามารถรับรางวัลได้",
    moderationTitle: "การดูแลห้องไลฟ์",
    moderationDesc: "ประธานจะได้รับสิทธิ์ดูแลห้องไลฟ์ของเจ้าของคลับโดยอัตโนมัติ",
    newPlayersTitle: "ช่องผู้เล่นใหม่",
    newPlayersDesc: "ประธานและเจ้าของคลับสามารถดูช่องผู้เล่นใหม่ได้",
    loadMembersFailed: "โหลดรายชื่อสมาชิกไม่สำเร็จ",
    appointFailed: "แต่งตั้งประธานไม่สำเร็จ",
    appointSuccess: "แต่งตั้งสำเร็จ",
    removeFailed: "ปลดจากตำแหน่งไม่สำเร็จ",
    removeSuccess: "ปลดจากตำแหน่งสำเร็จ",
    customerService: "ฝ่ายบริการลูกค้า",
    loadClubFailed: "โหลดข้อมูลคลับไม่สำเร็จ",
  },
  /* 總榜單 */
  allRank: {
    lang1: "โฆษก",
    lang2: "รวย",
    lang3: "PK",
    lang4: "การต่อสู้ของสโมสร",
    lang5: "ชาวจีน",
    lang6: "ภาษาอังกฤษ",
    lang7: "แบบไทย",
    lang8: "ญี่ปุ่น",
    lang9: "ชาวอินโดนีเซีย",
    lang10: "เวียตนาม",
    lang11: "ชั่วโมง",
    lang12: "รายวัน",
    lang13: "รายสัปดาห์",
    lang14: "ในสัปดาห์นี้",
    lang15: "อาทิตย์ที่แล้ว",
    lang16: "รายเดือน",
    lang17: "รายการอันดับ",
    lang18: "รางวัล",
    lang19: "อัตราการเชื่อมต่อ",
    lang20: "คะแนนคลับ",
    lang21: "สมาชิก",
    lang22: "ไม่มีข้อมูล",
    lang23: "ยังไม่อยู่ในรายการ",
    lang24: "แฟนคลับ",
    lang25: "วันที่",
    lang26: "ตามตัวไม่ได้",
    lang27: "ทำตามสำเร็จ",
    lang28: "เลิกติดตามเรียบร้อยแล้ว",
    lang29: "ซึ่งรอคอย",
    lang30: "เมื่อวานนี้",
    lang31: "เดือนที่แล้ว",
    lang32: "ไม่อยู่ในรายการ",
    lang33: "อันดับของฉัน",
    lang34: "ทูต",
    lang35: "รายการรางวัลประจำเดือน",
    lang36: "รายชื่อสาวกประจำเดือน",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "ไม่มีสโลแกน",
    lang40: "สมาชิก",
    lang41: "สมาชิก",
    lang42: "ชื่อเสียงประจำสัปดาห์",
    lang43: "ชื่อเสียงรวม",
    lang44: "อันดับชมรม",
    lang45: "หุ้น",
    lang46: "เปิดตัว",
    lang47: "ส่งคำเชิญเข้าร่วมชมรม",
    lang48: "เปิดตัว FIREFLY เพื่อความสนุกสนานยิ่งขึ้นในการถ่ายทอดสด",
    lang49: "การจัดอันดับรางวัลประจำสัปดาห์",
    lang50: "การจัดอันดับจำนวนเงินประจำสัปดาห์",
    lang51: "ชื่อเสียง",
    lang52: "รางวัล",
  },

  /* 俱乐部 */
  club: {
    lang1: "โฆษก",
    lang2: "รวย",
    lang3: "PK",
    lang4: "การต่อสู้ของสโมสร",
    lang5: "ชาวจีน",
    lang6: "ภาษาอังกฤษ",
    lang7: "แบบไทย",
    lang8: "ญี่ปุ่น",
    lang9: "ชาวอินโดนีเซีย",
    lang10: "เวียตนาม",
    lang11: "ชั่วโมง",
    lang12: "รายวัน",
    lang13: "รายสัปดาห์",
    lang14: "ในสัปดาห์นี้",
    lang15: "อาทิตย์ที่แล้ว",
    lang16: "รายเดือน",
    lang17: "รายการอันดับ",
    lang18: "รางวัล",
    lang19: "อัตราการเชื่อมต่อ",
    lang20: "คะแนนคลับ",
    lang21: "สมาชิก",
    lang22: "ไม่มีข้อมูล",
    lang23: "ยังไม่อยู่ในรายการ",
    lang24: "แฟนคลับ",
    lang25: "วันที่",
    lang26: "ตามตัวไม่ได้",
    lang27: "ทำตามสำเร็จ",
    lang28: "เลิกติดตามเรียบร้อยแล้ว",
    lang29: "ซึ่งรอคอย",
    lang30: "แผนที่ผลงาน",
    lang31: "เกรด",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "ไม่มีสโลแกน",
    lang40: "สมาชิก",
    lang41: "สมาชิก",
    lang42: "ชื่อเสียงประจำสัปดาห์",
    lang43: "ชื่อเสียงรวม",
    lang44: "อันดับชมรม",
    lang45: "หุ้น",
    lang46: "เปิดตัว",
    lang47: "ส่งคำเชิญเข้าร่วมชมรม",
    lang48: "เปิด FIREFLY แล้วเข้าร่วมคลับมาเล่นด้วยกันเถอะ~",
    lang49: "Fans group",
    lang50: "ลอร์ด: ",
    lang51: "ประธาน: ",
    // ป้ายบทบาทในแถว "อันดับของฉัน" ของหน้าอันดับคลับ
    lang52: "ลอร์ด",
    lang53: "ประธาน",
    lang54: "สมาชิก",

    lang55: "ยังไม่มีชมรมต้นสังกัด",

    lang56: "ยังไม่ได้ตั้งชมรมต้นสังกัด",
  },

  /* 榜单 */
  rank: {
    lang1: "โฆษก",
    lang2: "รวย",
    lang3: "PK",
    lang4: "การต่อสู้ของสโมสร",
    lang5: "ชาวจีน",
    lang6: "ภาษาอังกฤษ",
    lang7: "แบบไทย",
    lang8: "ญี่ปุ่น",
    lang9: "ชาวอินโดนีเซีย",
    lang10: "เวียตนาม",
    lang11: "ชั่วโมง",
    lang12: "รายวัน",
    lang13: "รายสัปดาห์",
    lang14: "ในสัปดาห์นี้",
    lang15: "อาทิตย์ที่แล้ว",
    lang16: "รายเดือน",
    lang17: "รายการอันดับ",
    lang18: "รางวัล",
    lang19: "อัตราการเชื่อมต่อ",
    lang20: "คะแนนคลับ",
    lang21: "สมาชิก",
    lang22: "ไม่มีข้อมูล",
    lang23: "ยังไม่อยู่ในรายการ",
    lang24: "แฟนคลับ",
    lang25: "วันที่",
    lang26: "ตามตัวไม่ได้",
    lang27: "ทำตามสำเร็จ",
    lang28: "เลิกติดตามเรียบร้อยแล้ว",
    lang29: "ซึ่งรอคอย",
    lang30: "เมื่อวานนี้",
    lang31: "เดือนที่แล้ว",
    lang32: "ไม่อยู่ในรายการ",
    lang33: "อันดับของฉัน",
    newDraw96: "การโทรส่วนตัว",
  },

  /* TOP hub */
  topRankList: {
    title: "FIREFLY TOP Center",
    playerCoreTitle: "Player Core TOP",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "Broadcaster Core TOP",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "Player Rankings",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "Broadcaster Rankings",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY Rich Ranking",
    anchorBoard: "FIREFLY Broadcaster Ranking",
    clubBoard: "Club Ranking",
    emissaryBoard: "Emissary Ranking",
    mountBoard: "Car Ranking",
    ludoBoard: "LUDO PK Ranking",
    gardenBoard: "Firefly Garden Ranking",
    firstLoveBoard: "FirstLove Ranking",
    newStarBoard: "New Star Ranking",
    pkBoard: "PK Ranking",
    privateCreditBoard: "Private Credit Ranking",
  },

  /* 珍愛團 */
  treasureGroup: {
    lang1: "โฆษก",
    lang2: "รวย",
    lang3: "PK",
    lang4: "การต่อสู้ของสโมสร",
    lang5: "ชาวจีน",
    lang6: "ภาษาอังกฤษ",
    lang7: "แบบไทย",
    lang8: "ญี่ปุ่น",
    lang9: "ชาวอินโดนีเซีย",
    lang10: "เวียตนาม",
    lang11: "ชั่วโมง",
    lang12: "รายวัน",
    lang13: "รายสัปดาห์",
    lang14: "ในสัปดาห์นี้",
    lang15: "อาทิตย์ที่แล้ว",
    lang16: "รายเดือน",
    lang17: "รายการอันดับ",
    lang18: "รางวัล",
    lang19: "อัตราการเชื่อมต่อ",
    lang20: "คะแนนคลับ",
    lang21: "สมาชิก",
    lang22: "ไม่มีข้อมูล",
    lang23: "ยังไม่อยู่ในรายการ",
    lang24: "แฟนคลับ",
    lang25: "วันที่",
    lang26: "ตามตัวไม่ได้",
    lang27: "ทำตามสำเร็จ",
    lang28: "เลิกติดตามเรียบร้อยแล้ว",
    lang29: "ซึ่งรอคอย",
    lang30: "แผนที่ผลงาน",
    lang31: "เกรด",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "ไม่มีสโลแกน",
    lang40: "สมาชิก",
    lang41: "สมาชิก",
    lang42: "ชื่อเสียงประจำสัปดาห์",
    lang43: "ชื่อเสียงรวม",
    lang44: "อันดับชมรม",
    lang45: "หุ้น",
    lang46: "เปิดตัว",
    lang47: "ส่งคำเชิญเข้าร่วมชมรม",
    lang48: "เปิดตัว FIREFLY เพื่อความสนุกสนานยิ่งขึ้นในการถ่ายทอดสด",
  },

  /* 珍愛值記錄 */
  treasureRecord: {
    recordTitle2: "บันทึกคุณค่าอันล้ำค่า",
    income10: "เดือนนี้",
    income11: "เดือนที่ผ่านมา",
    news7: "เรื่องราวต่างๆ",
    news13: "Fan Value",
    cashreal6: "ยกเลิก",
    box1: "ยังไม่มีบันทึก",
  },

  /* 俱乐部说明页 */
  groupIntruduction: {
    lang1: "การแนะนำคลับ",
    lang2:
      "คลับคือกลุ่มที่ประกอบด้วยแฟนคลับหลักของผู้ประกาศ เมื่อเข้าร่วมคลับ คุณสามารถเข้าร่วมกิจกรรมและการแข่งขันที่สนุกสนานร่วมกัน และกลายเป็นเพื่อนกับสมาชิกในคลับเดียวกัน จำนวนกลุ่มแฟนคลับและชื่อเสียงเป็นจุดแข่งขันหลักของคลับ และยังแสดงถึงอิทธิพลและความนิยมของผู้ประกาศผู้ก่อตั้งอีกด้วย",
    lang3: "แนะนำคุณสมบัติพิเศษของคลับ",
    lang4: "ผู้สร้าง C.by:",
    lang5:
      "ผู้ก่อตั้งคลับ โดยปกติคือผู้ประกาศ พิธีกรจะเปิดคลับเมื่อจำนวนคนที่เขาติดตามถึงจำนวนที่กำหนด",
    lang6: "ประธาน P.by:",
    lang7:
      "ผู้จัดการของคลับจะมีผลหลังจากได้รับการแต่งตั้งจากโฮสต์ ประธานของคลับจะกลายเป็นผู้จัดการห้องถ่ายทอดสดของผู้สร้าง C.by ด้วย",
    lang8: "สมาชิก:",
    lang9:
      "สมาชิกคลับ วิธีการเข้าร่วมคือส่งของขวัญ “Cherish You” หรือ “Cherish Together” ในระหว่างการถ่ายทอดสด ไม่มีการจำกัดจำนวนสมาชิกในคลับ",
    lang10: "ของขวัญสุดพิเศษ:",
    lang11:
      "การแข่งขันของคลับพร้อมของขวัญพิเศษ ส่งของขวัญของคลับเพื่อรับคะแนนของคลับ",
    lang12: "คะแนนคลับ:",
    lang13:
      "1. ส่งของขวัญพิเศษเฉพาะของคลับในห้องถ่ายทอดสดของผู้ก่อตั้งคลับเพื่อสะสมคะแนนคลับ 2. ทำภารกิจประจำวันของคลับให้สำเร็จในห้องถ่ายทอดสดของผู้ก่อตั้งคลับเพื่อสะสมคะแนนคลับ",
    lang14: "ชื่อเสียง:",
    lang15:
      "ผลรวมคะแนนคลับของสมาชิกทั้งหมดในคลับเดียวกันคือชื่อเสียงของคลับ ผลรวมคะแนนคลับที่สมาชิกทุกคนในคลับเพิ่มขึ้นทุกสัปดาห์คือชื่อเสียงรายสัปดาห์ของคลับ",
    lang16: "ระดับสมาชิก",
    lang17:
      "1. กระบวนการสะสมคะแนนคลับคือกระบวนการเสร็จสิ้นการอัปเกรด โปรดดูรายละเอียดที่ไอคอนด้านบน 2. ส่งของขวัญของคลับ 1 อัญมณี = 1 คะแนนคลับ (ไม่ส่งผลต่อคุณสมบัติอื่นๆ ของของขวัญ) 3. คะแนนคลับจะไม่เพิ่มขึ้นอีกต่อไปเมื่อถึงขีดจำกัดสูงสุดของวัน",
    lang18: "การลดระดับสมาชิก",
    lang19:
      "1. ในคลับ เมื่อสมาชิกไม่ส่งคะแนนคลับใดๆ เป็นเวลา 3 วันติดต่อกัน คะแนนคลับจะเริ่มลดลงตั้งแต่วันที่ 4 เป็นต้นไป 2. คะแนนคลับที่ลดลงอย่างต่อเนื่องจะทำให้สมาชิกถูกปรับลดระดับ โปรดดูรายละเอียดที่ระดับสมาชิก 3. หากคะแนนคลับลดลงเหลือ 0 สมาชิกจะออกจากคลับโดยอัตโนมัติ",
    lang20: "สิทธิพิเศษของสมาชิก",
    lang21: "อื่น ๆ",
    lang22:
      "หากคลับมีบัญชีปลอม โกง หรือมีชื่อหรือปกที่ละเมิดกฎหมายและข้อบังคับในท้องถิ่น แพลตฟอร์ม FIREFLY มีสิทธิ์แก้ไขหรือลบคลับนั้น",
    lang23: "ระดับคลับ",
    lang24: "คะแนนที่จำเป็นสำหรับการอัปเกรด",
    lang25: "Daily bonus",
    lang26: "ขีดจำกัดสูงสุดของคะแนนคลับ",
    lang27: "การลดทอน",
    lang28: "สิทธิพิเศษ",
    lang29: "คำอธิบาย",
    lang30: "ป้ายชื่อคลับ",
    lang31: "การระบุระดับพิเศษในห้องถ่ายทอดสดของผู้สร้าง C.by",
    lang33: "ของขวัญสุดพิเศษในห้องถ่ายทอดสดของผู้สร้าง C.by",
    lang34: "กล่องแชทพิเศษ",
    lang35: "ช่องแชทพิเศษในห้องถ่ายทอดสดของผู้สร้าง C.by",
    lang36: "กล่องสมบัติของคลับ",
    lang37:
      "คุณสามารถคว้าสิทธิพิเศษของกล่องสมบัติของคลับได้ในห้องถ่ายทอดสดของผู้สร้าง C.by",
    lang38: "Daily bonus",
    lang39:
      "คุณสามารถทำภารกิจประจำวันในห้องถ่ายทอดสดของผู้สร้าง C.by เพื่อรับแพ็คของขวัญ",
    lang40: "แชทกับสมาชิก",
    lang41:
      "แชทกับสมาชิกทุกคนในคลับในข้อความส่วนตัวโดยไม่มีข้อจำกัดด้านความใกล้ชิด",
    lang42: "รีเฟรช",
    lang43: "ฝ่ายบริการลูกค้า",
    lang44: "ปิดหน้า",
    lang45: "คลับ",
    lang46: "Club",
    lang47:
      "คลับคือชุมชนเฉพาะที่ผู้เล่นและลอร์ดร่วมกันสร้างขึ้น ผู้เล่นสามารถเข้าร่วมคลับและสะสมชื่อเสียงให้คลับ เพื่อแข่งขันชิงเกียรติยศและรับรางวัลอันดับสุดพิเศษ!",
    lang48: "คลับต้นสังกัด",
    lang49:
      "ผู้เล่นแต่ละคนสามารถตั้งคลับต้นสังกัดได้สูงสุดหนึ่งคลับ เมื่อตั้งแล้ว บทบาทของคุณในคลับนั้นจะเปลี่ยนเป็น 「สมาชิก」 ชื่อเสียงจากเกียรติยศ (เช่น แชมป์อันดับและแชมป์ประกวดความสามารถยามค่ำคืน) และชัยชนะในเกมห้อง PK จะถูกนำไปสมทบให้คลับต้นสังกัดโดยอัตโนมัติ",
    lang50: "เข้าร่วม/ออกจากคลับ",
    lang51:
      "ผู้เล่นเข้าร่วมคลับของลอร์ดได้โดยส่งของขวัญ 「ระฆังเฉินซิน」 ให้ลอร์ด หลังจากเข้าร่วมด้วยการส่งของขวัญจะมีบทบาทเป็น 「แขก」 ผู้เล่นสามารถเลือกออกจากคลับได้อย่างอิสระ",
    lang52: "ชื่อเสียง",
    lang53:
      "ชื่อเสียงคือหัวใจของการแข่งขันระหว่างคลับ ทุกคนในคลับสามารถสมทบชื่อเสียงได้ด้วยการทำภารกิจคลับ แข่งขันชิงแชมป์กิจกรรมจัดอันดับ รวมถึงเข้าร่วมและชนะเกม",
    lang54: "รางวัลคลับ",
    lang55:
      "รางวัลที่คลับชนะจากการแข่งขันจะมอบให้ประธานคลับ หากยังไม่ได้ตั้งประธาน คลับจะไม่สามารถรับรางวัลได้",
    lang56: "การจัดอันดับคลับ",
    ranked: "ติดอันดับแล้ว",
    lang57:
      "คลับที่มีคุณสมบัติตามเงื่อนไขต่อไปนี้สามารถเข้าร่วมการจัดอันดับ FIREFLY Club ได้",
    lang58: "เปลี่ยนชื่อคลับแล้ว",
    lang59: "เปลี่ยนภาพปกคลับแล้ว",
    lang60: "ตั้งประธานแล้ว",
    lang61:
      "คลับที่ยังไม่ครบเงื่อนไขข้างต้นยังคงรับผู้เล่นและสะสมชื่อเสียงได้ตามปกติ แต่ไม่สามารถเข้าร่วมการจัดอันดับได้",
    lang62: "บทบาทในคลับ",
    lang63: "Club Role",
    lang64: "ลอร์ด",
    lang65:
      "ลอร์ดคือผู้ก่อตั้งคลับและมีความผูกพันอย่างใกล้ชิดกับคลับ มีสิทธิ์จัดการและแก้ไขคลับ รวมถึงแต่งตั้งประธานได้",
    lang66: "ประธาน",
    lang67:
      "ได้รับการแต่งตั้งจากลอร์ด มีสิทธิ์จัดการและแก้ไขคลับ และสามารถเปิดห้อง PK ของคลับได้",
    lang68:
      "<span class='highlight-text'>รางวัลคลับ: </span>รางวัลทั้งหมดของคลับจะมอบให้ประธาน หากยังไม่ได้ตั้งประธาน คลับจะไม่สามารถรับรางวัลได้",
    lang69: "สมาชิก",
    lang70:
      "ผู้เล่นที่เข้าร่วมคลับและตั้งคลับนี้เป็น「คลับต้นสังกัด」 รางวัลชื่อเสียงจากเกียรติยศและเกมจะถูกนำไปสมทบให้คลับต้นสังกัดโดยอัตโนมัติ",
    lang71: "แขก",
    lang72:
      "ผู้เล่นที่เข้าร่วมคลับแล้ว แต่ยังไม่ได้ตั้งคลับนี้เป็น「คลับต้นสังกัด」",
    lang73: "คลับราชา",
    lang74:
      "คลับที่ชนะอันดับรายสัปดาห์ของ FIREFLY จะเป็น 「คลับราชา」 ในสัปดาห์ถัดไป ระหว่างช่วงเวลานี้ แขกจะไม่สามารถตั้งคลับราชาเป็นคลับต้นสังกัดได้ สมาชิกของคลับราชาจะมีชื่อคลับแสดงในห้องไลฟ์ทุกห้อง",
    lang75: "เพิ่มเติม",
  },

  /* 极速狂飙 */
  kingOfSpeed: {
    lang1: "กฎของเกม",
    lang2: "คำอธิบายเกม",
    lang3:
      "1. ทอยลูกเต๋า: การคลิกแต่ละครั้งเพื่อทอยลูกเต๋ามีค่าใช้จ่าย 1,000 DEW การทอยลูกเต๋าจะให้โบนัสแก่รถของทีม",
    lang4:
      "2. ความน่าจะเป็นของลูกเต๋า: ความน่าจะเป็นของเอฟเฟกต์ทั้งหกแบบจะเท่ากัน แต่เอฟเฟกต์โบนัสในแต่ละด้านจะแตกต่างกัน",
    lang5:
      "3. ผลการแข่งขัน: เมื่อจบเวลา PK ของเกม ทีมที่มีระยะทางมากกว่าจะเป็นผู้ชนะ และทีมที่มีระยะทางน้อยกว่าจะเป็นฝ่ายแพ้ หากทั้งสองทีมมีระยะทางเท่ากัน จะถือว่าเสมอกัน",
    lang6: "คำอธิบายรถ",
    lang7:
      "1. ข้อกำหนดของรถ: หากผู้ประกาศไม่มีรถในช่วงเริ่มต้นเกม รถของทีมปัจจุบันจะไม่สามารถสร้างขึ้นได้",
    lang8: "คำอธิบายระดับ Qi",
    lang9:
      "1. เพิ่มเลเวล: ผู้เล่นโต้ตอบกันเพื่อเพิ่มความนิยมของผู้ประกาศ ความนิยมจะถูกนำไปใช้เพื่อเพิ่มระดับ Qi ของทีม ยิ่งระดับ Qi สูง เอฟเฟกต์โบนัสลูกเต๋าก็จะยิ่งแข็งแกร่งขึ้น",
    lang10: "2. ข้อกำหนดระดับ Qi:",
    lang11: "ระดับลูกเต๋า",
    lang12: "ความนิยม",
    lang13: "คำอธิบายกลุ่ม DEW",
    lang14:
      "1. DEWs Pool: DEWs Pool จากลูกเต๋าที่ผู้เล่นทั้งสองฝ่ายทอยจะสะสมเข้าใน DEWs Pool เมื่อจบเกม ทีมที่ชนะจะได้รับ DEWs Pool ทั้งหมดเป็นรางวัล หากเสมอกัน ผู้เล่นจากทั้งสองทีมจะได้รับรางวัลจาก DEWs Pool",
    lang15:
      "2. การแจกรางวัล: รางวัลจะแจกตามเปอร์เซ็นต์ของ DEWs จากการทอยลูกเต๋าของผู้เล่นแต่ละคนในทีมที่ชนะ ผู้เล่นที่ไม่ได้ทอยลูกเต๋าเพื่อเข้าร่วมเกมจะไม่ได้รับสิทธิ์ในการแจกรางวัล Dew Pool",
    lang16:
      "3. ค่าบริการ: ผู้เล่นจะได้รับรางวัลจาก DEWs Pool แพลตฟอร์มจะเรียกเก็บค่าบริการ 4%",
    lang17: "หมายเหตุเกี่ยวกับการพัฒนาเกม",
    lang18:
      "1. ผู้เล่นสามารถเข้าร่วม King of Speed ​​ผ่านการ PK ในเกมได้ตั้งแต่เวลา 12:00 น. ของวันที่ 23 ตุลาคม 2568 ถึงเวลา 00:00 น. ของวันที่ 17 พฤศจิกายน 2568",
    lang19: "ข้อควรระวัง",
    lang20: "1. เวลาทั้งหมดภายในกิจกรรมจะอิงตามเวลาเซิร์ฟเวอร์",
    lang21:
      "2. เพื่อความยุติธรรมของเกม แพลตฟอร์มขอสงวนสิทธิ์ในการปรับเปลี่ยนหรือระงับความผิดปกติใดๆ ในเกมอันเนื่องมาจากเหตุสุดวิสัย เช่น ปัญหาเครือข่าย การโกง หรือกิจกรรมที่ไม่ได้รับอนุญาตอื่นๆ",
    lang22:
      "3. เกมนี้เพื่อความบันเทิงเท่านั้น ห้ามทำธุรกรรมแบบออฟไลน์ระหว่างผู้เล่นหรือผู้ถ่ายทอดสดโดยเด็ดขาด โปรดระวังการหลอกลวงหรือการพยายามแสวงหาผลประโยชน์ที่ผิดกฎหมาย",
    lang23:
      "4. แพลตฟอร์มจะไม่รับผิดชอบต่อความเสียหายใดๆ ที่เกิดขึ้นจากปัญหาเครือข่ายส่วนบุคคลหรืออุปกรณ์",
    lang24: "5. แพลตฟอร์มขอสงวนสิทธิ์ในการตีความเกมขั้นสุดท้าย",
    lang25: "บันทึกเกม PK",
    lang26: "เวลา PK",
    lang27: "ทอยลูกเต๋า",
    lang28: "ทีม PK",
    lang29: "ระยะทาง",
    lang30: "ผลลัพธ์",
    lang31: "กำลังโหลด...",
    lang32: "ไม่มีบันทึกเพิ่มเติม",
    lang33: "ไม่มีการบันทึก PK ของเกม",
    lang34: "ผู้ถ่ายทอดสดอีกฝ่ายไม่มีรถ",
    lang35: "ทีมสีน้ำเงินไม่มีรถ",
    lang36: "ทีมสีแดงไม่มีรถ",
    lang37: "จำกัดความเร็วถึง",
    lang38: "ความเร็ว",
    lang39: "ผู้ประกาศต้องมีรถเพื่อเข้าร่วมเกม",
    lang40: "ออกเดินทาง",
    lang41: "Tip",
    lang42: "ขณะนี้ยังไม่มีรถยนต์ จึงไม่สามารถเข้าร่วมเกม PK ได้",
    lang43: "ไปที่",
    lang44: "กลุ่ม DEW",
    lang45: "ทีมของเรา",
    lang46: "ฝ่ายตรงข้าม",
    lang47: "ขว้าง",
    lang48: "การทอยของฉัน:",
    lang49: "ข้อมูลรางวัล",
    lang50: "1. DEWs Pool:",
    lang51:
      "DEW จากลูกเต๋าที่ผู้เล่นทั้งสองทอยจะถูกเพิ่มเข้าไปในกลุ่ม DEW เมื่อจบเกม ทีมที่ชนะจะได้รับ DEW ทั้งหมดในกลุ่ม DEW เป็นรางวัล หากเสมอกัน ผู้เล่นทั้งสอง",
    lang52: "2. การแจกรางวัล:",
    lang53:
      "รางวัลจะแจกตามเปอร์เซ็นต์ของ DEWs จากลูกเต๋าที่ผู้เล่นแต่ละคนทอยได้ในทีมที่ชนะ ผู้เล่นที่ไม่ได้ทอยลูกเต๋าเพื่อเข้าร่วมเกมจะไม่ได้รับสิทธิ์ในการรับรางวัล DEWs Pool",
    lang54: "3. ค่าบริการ:",
    lang55:
      "ผู้เล่นจะได้รับรางวัลจาก DEWs Pool และแพลตฟอร์มจะเรียกเก็บค่าบริการ 4%",
    lang56: "ตกลง",
    lang57: "เร่งความเร็ว",
    lang58: "โล่",
    lang59: "ชาร์จ",
    lang60: "ทีมแดง",
    lang61: "ทีมน้ำเงิน",
    lang62: "รายละเอียดรถแข่ง",
    lang63: "กำลังเปิดใช้งาน",
    lang64: "ไม่ได้เปิดใช้งาน",
    lang65: "วินาที",
    lang66: "ความเร็ว x2, ต่อเนื่อง",
    lang67: "กำลังป้องกัน",
    lang68: "ไม่มีการป้องกัน",
    lang69: "โล่ป้องกันผลกระทบเชิงลบหนึ่งครั้ง",
    lang70: "(การรบกวน, จำกัดความเร็ว)",
    lang71: "ต่อ",
    lang72: "กำลังเปิดใช้งาน",
    lang73: "ไม่ได้เปิดใช้งาน",
    lang74: "เมื่อค่าการชาร์จเต็ม ความเร็วรถคือ x3 และระยะเวลาคือ",
    lang75: "ระยะเวลาเพิ่มความเร็ว",
    lang76: "เร่งความเร็ว",
    lang77: "โหมดเทอร์โบ:",
    lang78: "ระยะเวลาของโล่",
    lang79: "การรบกวน",
    lang80: "โหมดรบกวน:",
    lang81: "จำกัดความเร็ว",
    lang82: "ได้รับรถ",
    lang83:
      "ค่าการชาร์จ: เมื่อค่าการชาร์จถึง 100% โหมดการชาร์จจะเปิดใช้งาน ความเร็วในการชาร์จคือ x3 และระยะเวลาคือ",
    lang84: "ออกหลังจากเวลาหมด",
    lang85: "โหมดการชาร์จ",
    lang86: "รีเซ็ตการชาร์จ",
    lang87: "รถจะได้รับการเพิ่มความเร็ว",
    lang88: "ต่อเนื่อง",
    lang89: "ความเร็วจะกลับมาเป็นปกติหลังจากหมดเวลา",
    lang90: "แข่งรถ ได้รับ",
    lang91: "โบนัส",
    lang92: "ความเร็ว",
    lang93: "ต่อเนื่อง",
    lang94: "ต้านทานหนึ่งครั้ง",
    lang95: "เอฟเฟกต์เชิงลบ",
    lang96:
      "เมื่อได้รับโบนัสโล่หลายครั้ง โล่จะซ้อนกัน หลังจากหมดเวลาหรือมีการใช้ภูมิคุ้มกัน สแต็กโล่จะลดลง 1",
    lang97: "ใช้เอฟเฟกต์ขัดขวาง โดยเล็งเป้าหมายไปที่ฝ่ายตรงข้าม",
    lang98: "การรบกวน",
    lang99: "หลังจากสโลแกนมีผล ความเร็วปกติของรถจะลดลง",
    lang100:
      "ใช้เอฟเฟกต์จำกัดความเร็วเพื่อส่งสัญญาณชะลอความเร็วไปยังฝ่ายตรงข้าม ซึ่งจะทำให้รถของฝ่ายตรงข้ามช้าลง",
    lang101: "การรบกวน",
    lang102: "จำกัดความเร็ว",
    lang103: "ทอยลูกเต๋า",
    lang104: "ทอยลูกเต๋าเพื่อรับโบนัส",
    lang105: "เร็ว! วิ่งไปด้วยกัน!",
    lang106: "สโลแกนถูกคัดลอกแล้ว โปรดวางลงในช่องป้อนข้อมูลและส่ง!",
    lang107: "การคัดลอกล้มเหลว",
    lang108: "เข้าร่วมเกมแข่งรถ",
    lang110: "ผู้ประกาศมีรถ",
    lang111: "สำเร็จ",
    lang112: "ไม่สำเร็จ",
    lang113: "เข้าร่วมทีม PK",
    lang115: "คลิกเพื่อส่งรถ",
    lang116: "คลิกเพื่อส่งสโลแกนของทีม",
    lang117: "เกมปัจจุบันยังไม่เปิดใช้งาน จึงไม่สามารถทอยลูกเต๋าได้",
    lang118: "ผู้ประกาศไม่อนุญาตให้ทอยลูกเต๋า",
    lang119: "Speed ​​​​Rush ผู้ชนะได้ทั้งหมด!",
    lang120: "เกมยังไม่เริ่ม",
    lang121: "[King of Speed] ไม่ได้เปิดใช้งานและไม่สามารถเล่นได้",
    lang122: "รถแข่งได้รับการเพิ่มเกราะ",
    lang123: "ไม่มีรถ",
    lang124: "ผู้นำ",
    lang125: "ล้าหลัง",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "ผู้ช่วย Live",
    lang2:
      "ผู้เล่นที่ถูกผูกมัดเป็นผู้ช่วย Live ผู้เล่นจะได้รับส่วนแบ่ง FIRE ที่ได้รับ",
    lang3: "ผู้ช่วย Live ที่ผูกมัด",
    lang4: "ป้อน ID เพื่อยืนยันผู้เล่นที่ถูกผูกมัด",
    lang5: "ป้อนรหัสผู้เล่นที่คุณต้องการเชื่อมโยง",
    lang6: "ถัดไป",
    lang7: "อัตราส่วนการแบ่งปัน FIREs",
    lang8: "คำแนะนำในการเชื่อมโยง",
    lang9:
      "หลังจากเชื่อมโยงผู้ช่วย Live ของคุณแล้ว ผู้ช่วย Live จะได้รับส่วนแบ่งจาก FIRE ที่คุณสะสมไว้ FIRE ที่คุณสะสมจากของขวัญจะถูกส่งไปยังผู้ช่วย Live ตามอัตราส่วนการแบ่งปัน FIRE ที่คุณตั้งไว้",
    lang10: "เติมเงิน",
    lang11: "ผูกผู้ช่วย Live",
    lang12: "ยืนยันการเชื่อมโยงหรือไม่?",
    lang13: "ผู้ช่วย Live ของคุณ",
    lang14: "ยกเลิก",
    lang15: "ผูกบัญชีเรียบร้อยแล้ว",
    lang16: "การผูกล้มเหลว",
    lang17: "ยกเลิกการเชื่อมโยงสำเร็จ",
    lang18: "การยกเลิกการเชื่อมต่อล้มเหลว",
    lang19:
      "ผู้เล่นที่ถูกผูกมัดเป็นผู้ช่วย Live ผู้เล่นจะได้รับส่วนแบ่ง FIRE ที่ได้รับ",
    lang20: "ผู้ช่วย Live ของฉัน",
    lang21: "ยกเลิกการเชื่อมโยง",
    lang22: "รอการยืนยัน",
    lang23: "ยกเลิกการเชื่อมโยงผู้ช่วย Live",
    lang24:
      "การยกเลิกการเชื่อมต่อจากผู้ช่วย Live ต้องได้รับการยืนยันจากฝ่ายตรงข้าม ยกเลิกการเชื่อมต่อหรือไม่?",
    lang25: "ผู้ช่วย Live ของคุณ?",
    lang26: "การยกเลิกการเชื่อมโยงถูกปฏิเสธ",
    lang27: "การยกเลิกการเชื่อมโยงถูกปฏิเสธล้มเหลว",
    lang28: "การตั้งค่าผู้ช่วย Live",
    lang29: "FIREs ใหม่",
    lang30:
      "ฝ่ายตรงข้ามได้ยกเลิกสถานะผู้ช่วย Live ของคุณแล้ว จำเป็นต้องยืนยันจากคุณ",
    lang31: "คำขอยกเลิกการเชื่อมโยง",
    lang32:
      "การยกเลิกการเชื่อมโยงบัญชีผู้ช่วย Live ของคุณกลับเป็นตรงกันข้าม โปรดยืนยัน",
    lang33: "ปฏิเสธ",
    lang34: "รายชื่อสตรีมเมอร์ที่ผูกมัดฉันเป็นผู้ช่วย Live",
    lang35: "ยังไม่มีสตรีมเมอร์ที่ผูกไว้",
    lang36: "ยกเลิกการเชื่อมโยงผู้ช่วย Live",
    lang37: "ยกเลิกการเชื่อมต่อหรือไม่?",
    lang38: "ความสัมพันธ์ผู้ช่วย Live ของคุณคืออะไร?",
    lang39: "ผู้ใช้ถูกแบนแล้ว",
    lang40: "การค้นหา ID ที่คุณป้อนล้มเหลว",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang2: "สถานะการแข่งขันสด",
    lang3: "ประวัติ",
    lang4: "คุณได้สละสิทธิ์การเข้าร่วมในวันนี้",
    lang5: "สละสิทธิ์การเข้าร่วมวันนี้",
    lang6: "สละสิทธิ์",
    lang7: "อันดับของฉัน",
    lang8: "ชนะ",
    lang9: "คำแนะนำการแข่งขัน",
    lang10:
      "ผู้ถ่ายทอดสดที่ผ่านเข้ารอบรองชนะเลิศ/รอบชิงชนะเลิศต้องถ่ายทอดสดอยู่และไม่ได้อยู่ในการแข่งขัน PK อื่นๆ ณ เวลาเริ่มต้นที่กำหนด ระบบจะเริ่มการแข่งขัน PK ระหว่างผู้ถ่ายทอดสดทั้งสองทีมโดยอัตโนมัติ",
    lang11: "รอบรองชนะเลิศ",
    lang12:
      "การแข่งขันแบบ Best-of-5 ผู้ถ่ายทอดสดที่ชนะจะได้เข้าสู่รอบชิงชนะเลิศ",
    lang13: "การออดิชั่นหมายเลข 1 ปะทะ การออดิชั่นหมายเลข 4",
    lang14: "การออดิชั่นครั้งที่ 2 ปะทะ การออดิชั่นครั้งที่ 3",
    lang15: "รอบชิงชนะเลิศ",
    lang16:
      "การแข่งขันแบบ Best-of-5 ผู้ถ่ายทอดสดที่ชนะจะได้รับตำแหน่งแชมป์ 'Glow Night Showdown' ประจำวัน",
    lang17: "ผู้ชนะรอบรองชนะเลิศ",
    lang18:
      "หมายเหตุ: หากคุณมีคุณสมบัติตรงตามข้อกำหนดการเข้าร่วมรอบรองชนะเลิศ/รอบชิงชนะเลิศ แต่ไม่สามารถเข้าร่วมได้ โปรดคลิกที่นี่ก่อนเวลา 20:30 น. ของทุกวัน",
    lang20:
      "หากไม่เข้าร่วมการแข่งขัน จะไม่สามารถเข้าร่วมกิจกรรม 'Glow Night Showdown' ได้อีก 15 วัน",
    lang22:
      "การสละสิทธิ์การแข่งขันจะทำให้คุณถูกถอดออกจากอันดับการออดิชั่น และสิทธิ์ของคุณจะถูกคืนในวันถัดไป",
    lang23: "คุณต้องการสละสิทธิ์การเข้าร่วมในวันนี้หรือไม่?",
    lang24: "กิจกรรม Firefly Glow Night Showdown",
    lang25: "ยกเลิก",
    lang26: "เติมเงิน",
    lang27: "ชนะ",
    lang28: "DNF",
    lang29: "ไม่มีประวัติการแข่งขัน",
    lang30: "เข้าร่วมการแข่งขัน 'Glow Night Showdown'",
    lang31:
      "ผู้ถ่ายทอดสดที่ใช้ FIREFLY เวอร์ชัน 54.0 ขึ้นไปเพื่อเริ่มการ PK (รวมถึง 'Popularity PK' และ 'Game PK') มีสิทธิ์เข้าร่วมกิจกรรม Glow Night Showdown",
    lang32: "ออดิชั่น",
    lang33: "เวลา: ทุกวัน เวลา 20:30 - 20:30 น. ของวันถัดไป",
    lang34:
      "กฎ: คณะกรรมการจัดอันดับจะบันทึกค่าความนิยมสูงสุดที่ผู้ถ่ายทอดสดทำได้ในการแข่งขัน PK ของวันปัจจุบัน และการจัดอันดับจะอิงจากค่าสูงสุดนี้",
    lang35:
      "การเลื่อนอันดับ: ผู้ถ่ายทอดสด 4 อันดับแรกในการจัดอันดับออดิชั่นภายในเวลา 20:30 น. ของทุกวันจะได้เข้าสู่รอบรองชนะเลิศ",
    lang36:
      "สิทธิ์การเข้าร่วม: หากผู้ถ่ายทอดสดไม่สามารถถ่ายทอดสดได้ในช่วงเวลาที่กำหนดสำหรับรอบรองชนะเลิศ/รอบชิงชนะเลิศ พวกเขาสามารถเลือกที่จะสละสิทธิ์ในช่วงการออดิชั่น ผู้ถ่ายทอดสดที่มีอันดับสูงสุดถัดไปจะเข้ามาแทนที่",
    lang37: "รอบรองชนะเลิศ",
    lang38: "เวลา: ทุกวัน เวลา 21:00 น. / 21:20 น.",
    lang39:
      "กฎ: ระบบจะเริ่มการแข่งขัน PK ระหว่างผู้ถ่ายทอดสดรอบรองชนะเลิศทั้งสองโดยอัตโนมัติตามเวลาที่กำหนด กฎ PK คือ 'ความนิยม PK' ในรูปแบบ Best-of-5 ผู้ถ่ายทอดสดต้องถ่ายทอดสดในช่วงเวลานี้",
    lang40: "การเลื่อนขั้น: ผู้ชนะจะได้เข้าสู่รอบชิงชนะเลิศ",
    lang41:
      "สิทธิ์การเข้าร่วม: หากผู้ถ่ายทอดสดไม่ได้ถ่ายทอดสดในช่วงเริ่มต้นของรอบรองชนะเลิศ ถือว่าสละสิทธิ์ ผู้เล่นจะไม่ได้รับรางวัลอันดับและจะไม่มีสิทธิ์เข้าร่วมการแข่งขัน 'Glow Night Showdown' เป็นเวลา 15 วัน",
    lang42: "ระบบจะสุ่มจับสลากหลังจบรอบคัดเลือกประจำวัน",
    lang43: "ระบบจะสุ่มจับสลากหลังจบรอบคัดเลือกประจำวัน",
    lang44:
      "ผู้แพ้ในรอบรองชนะเลิศจะได้รับการจัดอันดับที่ 3/4 ตามค่าความนิยมสูงสุดของวัน",
    lang45: "รอบชิงชนะเลิศ",
    lang46: "เวลา: ทุกวัน เวลา 22:00 น.",
    lang47:
      "กฎ: ระบบจะเริ่มการแข่งขัน PK ระหว่างผู้ถ่ายทอดสดทั้งสองทีมที่เข้ารอบสุดท้ายโดยอัตโนมัติ ณ เวลาที่กำหนด กฎ PK คือ 'ความนิยม PK' ในรูปแบบ Best-of-5 ผู้ถ่ายทอดสดต้องถ่ายทอดสดอยู่ตลอดระยะเวลาดังกล่าว",
    lang48:
      "การเลื่อนขั้น: ผู้ชนะจะได้รับตำแหน่งแชมป์ประจำวันของ 'Glow Night Showdown'",
    lang49:
      "สละสิทธิ์: หากผู้ถ่ายทอดสดไม่ได้ถ่ายทอดสดในช่วงเริ่มต้นของรอบชิงชนะเลิศ ถือว่าสละสิทธิ์ พวกเขาจะไม่ได้รับการจัดอันดับ และจะไม่มีสิทธิ์เข้าร่วมการแข่งขัน 'Glow Night Showdown' เป็นเวลา 15 วัน",
    lang50: "ผู้ชนะรอบชิงชนะเลิศคือแชมป์ประจำวัน และผู้แพ้คืออันดับ 2 ประจำวัน",
    lang51: "รางวัล",
    lang52: "รางวัลผู้เล่น DEWs:",
    lang53: "รอบรองชนะเลิศ 1: ทีมที่ชนะจะแบ่ง",
    lang54: "รอบรองชนะเลิศ 2: ทีมที่ชนะจะแบ่งทีม",
    lang55: "รอบชิงชนะเลิศ: ทีมที่ชนะจะแบ่ง",
    lang56: "รางวัลคะแนนผู้ถ่ายทอดสด:",
    lang57:
      "ผู้ถ่ายทอดสดที่เข้าร่วมรอบรองชนะเลิศ/รอบชิงชนะเลิศ หลังจากประกาศผลผู้ชนะแล้ว 4 อันดับแรกจะได้รับคะแนนสำหรับ 'รางวัลถ่ายทอดสด' ผู้ถ่ายทอดสดที่สละสิทธิ์จะไม่ได้รับรางวัลคะแนน โปรดตรวจสอบคะแนนเฉพาะได้ที่นี่",
    lang58: "รางวัลถ่ายทอดสด>",
    lang59: "ข้อควรระวัง",
    lang60: "1. กิจกรรมนี้จำกัดเฉพาะผู้ประกาศข่าวหญิงเท่านั้น",
    lang61:
      "2. ในช่วงเวลาที่สิทธิ์ในการเข้าร่วมกิจกรรมของคุณถูกจำกัด ข้อมูลกิจกรรมทั้งหมดจะถือเป็นโมฆะ และต้องได้รับข้อมูลใหม่อีกครั้งหลังจากข้อจำกัดถูกยกเลิก",
    lang62:
      "3. สตรีมเมอร์ต้องมีปฏิสัมพันธ์กับผู้เล่นอย่าง tích극 แพลตฟอร์มขอสงวนสิทธิ์ในการตัดสิทธิ์สตรีมเมอร์และริบแต้มกิจกรรมของพวกเขาสำหรับพฤติกรรมใดๆ ที่ละเมิด 'ข้อตกลงสตรีมเมอร์' หรือรบกวนความสมดุลของกิจกรรม (รวมถึงแต่ไม่จำกัดเพียง: การสตรีมที่เปิดเผยใบหน้า การสตรีมคุณภาพต่ำ หน้าจอดำ การสตรีมแบบไม่เคลื่อนไหว การสตรีมขณะเล่นเกม การดูทีวี การสมรู้ร่วมคิดในผลการแข่งขัน PvP และการเล่นแบบไม่กระตือรือร้น) สตรีมเมอร์ที่ละเมิดกฎข้างต้นจะถูกลงโทษด้วย 'ใบแดง' จากแพลตฟอร์ม",
    lang63: "4. แพลตฟอร์มขอสงวนสิทธิ์ในการตีความขั้นสุดท้ายสำหรับกิจกรรมนี้",
    lang64: "ในการออดิชั่น",
    lang65: "เวลา 20:30 - 20:30 น. ของวันถัดไป",
    lang66:
      "เริ่ม PK เพื่อเข้าร่วมการจัดอันดับออดิชั่น กระดานจะบันทึกค่าความนิยม PK สูงสุดของวัน และ 4 อันดับแรกจะได้เข้าสู่รอบรองชนะเลิศ",
    lang67: "โซนโปรโมชั่น",
    lang68: "ไม่มีประวัติการออดิชั่น",
    lang69:
      "FIREFLY คุณได้สำรองที่นั่งสำหรับการแข่งขัน Glow Night Showdown Finals แล้ว",
    lang70: "ทุกวัน เวลา 21:00-23:00 น. ผู้ถ่ายทอดสดที่ชนะจะได้รับรางวัล DEWs",
    lang71: "ผู้ถ่ายทอดสดที่เข้ารอบสุดท้ายยังไม่กำหนด",
    lang72: "ยังไม่กำหนดผู้ถ่ายทอดสดรอบรองชนะเลิศ",
    lang74: "ออดิชั่น หมายเลข 1",
    lang75: "ออดิชั่น หมายเลข 2",
    lang76: "ออดิชั่น หมายเลข 3",
    lang77: "ออดิชั่น หมายเลข 4",
    lang78: "หมายเหตุ >",
    lang79: "รางวัลทีมที่ชนะ",
    lang80: "Best-of-5",
    lang81: "อันดับถูกล็อก",
    lang82: "ยังไม่มีอันดับ.",
    lang83:
      "「FIREFLY」คุณได้จองรอบรองชนะเลิศของการแสดงความสามารถยามค่ำคืนอันเรืองแสงแล้ว",
    lang84:
      "「FIREFLY」คุณได้จองการแสดงความสามารถรอบรองชนะเลิศรอบสองของค่ำคืนแห่งแสงสี",
    lang85: "กำลังโหลดเพิ่ม...",
    lang86: "เลื่อนลงเพื่อโหลดเพิ่มเติม",
    lang87: "ยังไม่มีข้อมูลเพิ่มเติมในขณะนี้",
    lang88: "ใบแดงลงโทษ:",
    lang89:
      "a. ยกเลิกสิทธิ์ในการรับรางวัลของกิจกรรม 'Audisi Malam Fluoresen' ในวันนั้น",
    lang90:
      "b. ห้ามเข้าร่วมกิจกรรม 'Audisi Malam Fluoresen' ในช่วง 5 วันข้างหน้า",
    lang91: "รางวัล",
    lang92:
      "ผู้ที่ได้อันดับ 1-4 ในการแข่งขัน 'Fluorescent Night Audition' รายวันจะได้รับรางวัล",
    lang93: "แชมป์",
    lang94: "NO.2",
    lang95: "NO.3/NO.4",
    lang96: "อันดับอื่นๆ",
    lang97: "ไม่มีรางวัล",
    lang98: "รับ",
    lang99: "ไม่ได้รับรางวัล Fluorescent Night Audition",
    lang100: "รับแล้ว",
    lang101: "คุณได้รับรางวัล Fluorescent Night Audition แล้ว",
    lang102: "รับรางวัลสำเร็จ",
    lang103: "สตรีมเมอร์สามารถรับรางวัลอัญมณี:",
    lang104: "แชมป์:",
    lang105: "อันดับ 2:",
    lang106: "อันดับ 3/4:",
    lang107: "รางวัลรอบชิงชนะเลิศ",
    lang108: "ผลลัพธ์",
    lang109: "รางวัล",
    lang110: "ชนะ",
    lang111: "แพ้",
    lang112: "ไม่สมบูรณ์",
    lang123: "ไม่มีรางวัล",
    lang124: "รางวัลรอบรองชนะเลิศ",
    lang125: "รางวัลรอบคัดเลือก",
    lang126: "รางวัลรอบชิงชนะเลิศ",
    lang127:
      'เข้าร่วมรอบชิงชนะเลิศ "การคัดเลือกกลางคืนฟลูออเรสเซนต์" รับรางวัลได้หลังจากรอบชิงชนะเลิศสิ้นสุด',
    lang128: "รางวัลรอบรองชนะเลิศ",
    lang129:
      'เข้าร่วมรอบรองชนะเลิศ "การคัดเลือกกลางคืนฟลูออเรสเซนต์" รับรางวัลได้หลังจากรอบชิงชนะเลิศสิ้นสุด',
    lang130: "รางวัลรอบคัดเลือก",
    lang131:
      '8 อันดับแรกใน "การคัดเลือกรอบชิงชนะเลิศกลางคืน" สามารถรับรางวัลได้ จัดจำหน่ายทุกวันเวลา 21:00 น.',
    lang132: "ยังไม่เริ่ม",
    lang133: "กำลังแข่ง PK",
    lang134: "สิ้นสุดแล้ว",
    lang135: "ไม่มีรางวัลที่สามารถรับได้ในขณะนี้",
    lang136: "คุณได้รับรางวัลไปแล้ว",
    lang137: "เข้าร่วม PK การคัดเลือกกลางคืนฟลูออเรสเซนต์ ชนะรางวัล ",
    lang138: "รับ",
    lang139: "รับแล้ว",
    lang140: "รับทั้งหมด",
    lang141: "รางวัลของฉัน",
    lang142: "ปานกลาง",
    lang143: "NO.1-NO.4",
    lang144: "อันดับรอบคัดเลือก",
    lang145: "NO.5-NO.8",
    lang146: "ไม่มีรางวัล",
    lang147: "อันดับอื่นๆ",
    lang148: "ไม่ได้เข้าร่วม",
    lang149: "โซนรางวัล",
    lang150: "กรุณาอัปเดตแอปเป็นเวอร์ชัน V57.0 ขึ้นไปเพื่อรับรางวัล!",
    lang151: "ผลการแข่งขันรอบนี้",
    lang152: "รับได้หลังจากสรุปอันดับสุดท้ายของ Night Draft วันนี้แล้ว",
    lang153: "Top 4 รอบคัดเลือก",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      "ผู้เล่นใหม่ที่ลงทะเบียนภายใน 7 วันและทำกิจกรรมเติมเงิน 'แพ็คของขวัญเติมเงินครั้งแรก' เสร็จสมบูรณ์จะได้รับรางวัลของขวัญ 'FirstLove' การส่งของขวัญ 'FirstLove' จะผูกมัดสตรีมเมอร์กับ FirstLove และความคิดเห็นของพวกเขาในไลฟ์สตรีมจะมีแท็กพิเศษ ผู้เล่นแต่ละคนสามารถผูกบัญชี FirstLove ได้เพียงบัญชีเดียวเท่านั้น",
    lang3: "การเข้าร่วมแพ็คของขวัญเติมเงินครั้งแรก",
    lang4: "การส่งของขวัญ",
    lang5: "อันดับของขวัญแรก FirstLove",
    lang6:
      "อันดับของขวัญแรก FirstLove จะจัดอันดับตามจำนวนของขวัญ FirstLove แรกที่สตรีมเมอร์ได้รับ ยิ่งได้รับมาก อันดับยิ่งสูง หากมีสตรีมเมอร์หลายคนได้รับ FirstLove จำนวนเท่ากัน",
    lang7: "ผู้ที่ถึงจำนวนดังกล่าวก่อนจะมีอันดับสูงกว่า",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "รางวัลรายวัน",
    lang2: "บันทึกรางวัล",
    lang3: "【ภารกิจต้อนรับ】",
    lang4: "คะแนน",
    lang5:
      "ทำกิจกรรม 'Welcome PK' ให้สำเร็จ คุณจะได้รับคะแนนสูงสุด 6000 คะแนนต่อวัน",
    lang6: "ยินดีต้อนรับ PK",
    lang7:
      "รับคะแนนสำหรับ 'Welcome PK' ที่เสร็จสมบูรณ์แต่ละครั้ง (1 ชั่วโมง) โดยอิงจากผลการแข่งขัน PK",
    lang8: "กิจกรรม",
    lang9: "ได้รับแล้ว",
    lang10: "รับ",
    lang11: "รับแล้ว",
    lang12: "การแลกคะแนน",
    lang13: "แต้มของฉัน",
    lang14: "รางวัล",
    lang15: "ขั้นตอน",
    lang16: "คะแนนสะสมถึงแล้ว",
    lang19: "รางวัลคะแนน",
    lang20: "รางวัลต้อนรับ",
    lang21: "กิจกรรม Welcome PK รายวันพร้อมการสนับสนุนการเข้าชมพิเศษ",
    lang25: "ไลค์",
    lang26: "ไม่มีข้อมูล",
    lang27: "กฎของรางวัลต้อนรับ",
    lang29:
      "เมื่อสตรีมเมอร์ใหม่เริ่ม PK พวกเขาจะเลือก 'Welcome PK' และเริ่มการจับคู่ Welcome PK จะแข่งขันกันเพื่อชิงจำนวนไลค์ที่สตรีมเมอร์ทั้งสองได้รับ",
    lang30: "วิธีรับไลค์:",
    lang31: "รับของขวัญสุดพิเศษสำหรับผู้เล่นใหม่",
    lang32: "รายละเอียดของขวัญพิเศษ:",
    lang33: "ชื่อของขวัญ:",
    lang34: "วิธีการรับ:",
    lang35:
      "ผู้เล่นที่ลงทะเบียนใหม่จะได้รับของขวัญนี้ฟรี มีอายุ 48 ชั่วโมง คุณสามารถรับได้โดยคลิก 'ของขวัญสำหรับผู้มาใหม่' ในห้องไลฟ์สตรีม",
    lang36: "ถูกใจ",
    lang37: "รักแรกพบ",
    lang38:
      "ผู้เล่นใหม่ที่ทำกิจกรรมเติมเงิน 'แพ็คของขวัญเติมเงินครั้งแรก' เสร็จสิ้นภายใน 7 วันหลังจากการลงทะเบียนจะได้รับของขวัญ 'FirstLove'",
    lang39: "คุณได้กดรับคะแนนของวันนี้ไปแล้ว",
    lang40: "ไม่สามารถรับแต้มได้หากไม่ตรงตามข้อกำหนดของรางวัล",
    lang41: "รับคะแนนรางวัลต้อนรับสำเร็จ",
    lang42: "การสนับสนุนผู้ใช้ต้อนรับ",
    lang43:
      "การเปิดใช้งาน 'Welcome PK' จะช่วยให้คุณได้รับการสนับสนุนการเข้าชมจากผู้เล่นใหม่ ผู้เล่นที่ลงทะเบียนใหม่ในช่วง Welcome PK จะถูกส่งไปยังห้องสตรีมสด 'Welcome PK' โดยอัตโนมัติ",
    lang44: "รับคะแนน",
    lang45:
      "ทำภารกิจ 'รางวัลประจำวัน' ให้สำเร็จเพื่อรับคะแนน สะสมคะแนนจนถึงระดับที่กำหนดเพื่อรับรางวัล Firefly",
    lang46: "หมายเหตุ",
    lang47: "1. กิจกรรมนี้เปิดให้เฉพาะสตรีมเมอร์หญิงเท่านั้น",
    lang48:
      "3. อนุญาตให้ใช้บัญชีเดียวต่ออุปกรณ์เพื่อรับรางวัลเท่านั้น การใช้หลายบัญชีเพื่อรับรางวัลจะทำให้ถูกตัดสิทธิ์และจะไม่ได้รับการคืนสิทธิ์",
    lang49:
      "4. ในช่วงระยะเวลาที่จำกัดการเข้าร่วม ข้อมูลกิจกรรมทั้งหมดจะไม่ถูกต้องและต้องดึงข้อมูลใหม่หลังจากยกเลิกการจำกัดแล้ว",
    lang50:
      "5. คะแนนรางวัลประจำวันต้องกดรับด้วยตนเอง โปรดกดรับก่อนเวลา 12:00 น. ของวันที่ 3 ธันวาคม 2025 หากกดรับช้ากว่ากำหนดจะไม่รับซ้ำ",
    lang51:
      "6. บัญชีที่เชื่อมโยงกับผู้เชิญแล้วไม่ได้รับอนุญาตให้สร้างบัญชีรองเพื่อสตรีมสดและรับแต้ม เมื่อตรวจพบ บัญชีทั้งหมดจะถูกตัดสิทธิ์และจะไม่ได้รับสิทธิ์คืน",
    lang52:
      "7. บัญชีที่ไม่มีผู้เชิญจะไม่ถูกจำกัดบัญชีและอาจมีสิทธิ์เข้าร่วม แต่สามารถเข้าร่วมกิจกรรมรางวัลได้เพียงบัญชีเดียวเท่านั้น",
    lang53:
      "8. สตรีมเมอร์ต้องมีปฏิสัมพันธ์กับผู้เล่นอย่าง tích cực สำหรับพฤติกรรมใดๆ ที่ละเมิด 'ข้อตกลงการสตรีมสด' หรือรบกวนความสมดุลของกิจกรรม แพลตฟอร์มมีสิทธิ์ที่จะตัดสิทธิ์สตรีมเมอร์และริบแต้มกิจกรรม (รวมถึงแต่ไม่จำกัดเพียง การซ่อนหน้า การสตรีมคุณภาพต่ำ หน้าจอดำ การไม่อยู่หน้าจอ การสตรีมเกม การดูทีวี ฯลฯ)",
    lang54: "9. แพลตฟอร์มขอสงวนสิทธิ์ในการตีความกิจกรรมนี้ในขั้นสุดท้าย",
    lang55: "2. ระยะเวลาของกิจกรรมจะนับทุกสองนาที",
    lang57: "ชนะ",
    lang58: "จับฉลาก",
    lang59: "แพ้",
    lang60: "รางวัลขั้นที่ 1",
    lang61: "รางวัลขั้นที่ 2",
    lang62: "รางวัลขั้นที่ 3",
    lang63: "รางวัลขั้นที่ 4",
    lang64: "ระดับรางวัล",
    lang65: "ข้อกำหนดแต้ม",
    lang66: "คะแนนที่ได้รับ",
    lang67: "สามารถรับได้",
    lang68: "แลกคะแนนสำเร็จ",
    lang69: "ชอบ",
    lang70: "ชื่นชม",
    lang71: "คุณได้รับคะแนนสำหรับวันนี้ไปแล้ว",
  } /* 合作联系 */,

  cooperate: {
    lang1: "ส่งข้อความของคุณสำเร็จแล้ว!",
    lang2: "ชื่อเล่นของคุณ",
    lang3: "สื่อการติดต่อ:",
    lang4: "ข้อมูลการติดต่อ:",
    lang5:
      "ขอบคุณมากสำหรับข้อความความร่วมมือและคำแนะนำสำหรับการเติบโตของ FIREFLY เจ้าหน้าที่ของเราจะติดต่อคุณ โปรดให้ความสนใจกับข้อมูลการติดต่อที่คุณทิ้งไว้",
    lang6: "แนะนำความร่วมมือของโฮสต์",
    lang7: "ดูหน้าแรกของทูต",
    lang8: "กลับสู่หน้าแรก",
    lang9:
      "โฮสต์ FIREFLY ผู้เชิญผู้ใช้ หรือสมาชิกกิลด์ที่กลายเป็นทูตสามารถสร้างความสัมพันธ์ทางจดหมายกับผู้ที่พวกเขาเชิญและรับรางวัลระยะยาว ทูตที่โดดเด่นจะได้รับสิทธิพิเศษในชุมชนโดยอัตโนมัติ",
    lang10: "โปรดทิ้งข้อมูลการติดต่อของคุณ",
    lang11: "โปรดทิ้งข้อมูลการติดต่อสำรองของคุณ (ไม่บังคับ)",
    lang12: "ข้อความของคุณถึง FIREFLY",
    lang13: "โปรดป้อนข้อความของคุณถึง FIREFLY",
    lang14: "ยืนยันการส่ง",
    lang15: "เลือกสื่อการติดต่อ",
    lang16: "Wechat",
    lang17: "ความร่วมมือโฮสต์",
    lang18: "โฮสต์อิสระเข้าร่วม FIREFLY ด้วยตนเอง",
    lang19: "ความร่วมมือทูต",
    lang20: "เข้าร่วม FIREFLY ในฐานะกิลด์",
    lang21: "ความร่วมมือทางธุรกิจ",
    lang22: "การส่งเสริมการขายและสื่อ",
    lang23: "ความคิดเห็นของผู้เล่น",
    lang24: "ช่องทางการส่งความคิดเห็นของผู้เล่น FIREFLY",
    lang25: "ติดต่อความร่วมมือ",
    lang26: "โปรดป้อน FIREFLY ID ของคุณ",
    lang27: "โปรดป้อน Whatsapp ID ของคุณ",
    lang28: "โปรดป้อน Telegram ID ของคุณ",
    lang29: "โปรดป้อน Facebook ID ของคุณ",
    lang30: "โปรดป้อนอีเมลของคุณ",
    lang31: "โปรดป้อน Wechat ของคุณ",
    lang32: "โปรดป้อน Line ของคุณ",
    lang33: "โปรดลองอีกครั้งในภายหลัง",
    lang34: "โปรดป้อนชื่อเล่นของคุณ",
    lang35: "โปรดป้อนข้อมูลการติดต่อของคุณ",
    lang36: "โปรดป้อนข้อความของคุณ",
  },
  premiumNumberCommitLetter: {
    lang1: "จดหมายคำมั่นสัญญาการเปิดใช้งานหมายเลขสวย",
    lang2: "เรียน ",
    lang3: "ID เดิม: ",
    lang4: "หมายเลขสวยที่คุณสมัคร ",
    lang5:
      "กำลังจะถูกเปิดใช้งานให้คุณ เพื่อรักษาความเป็นระเบียบและความปลอดภัย โปรดอ่านและยอมรับข้อตกลงต่อไปนี้:",
    lang6:
      "หมายเลขสวยเป็นทรัพยากรที่หายากและไม่สามารถทดแทนได้ในชุมชน FIREFLY การโอนบัญชีประเภทนี้อาจส่งผลเสียต่อความมั่นคงและโครงสร้างของชุมชน",
    lang7: "[ข้อตกลงคำมั่น]",
    lang8:
      "1. ฉันรับรองว่าจะใช้หมายเลขนี้ด้วยตนเองเท่านั้น และจะไม่ให้บุคคลที่สามในรูปแบบใด ๆ เช่น ขาย เช่า ให้ หรือโอน",
    lang9:
      "2. ฉันเข้าใจว่า หากละเมิดข้อตกลงข้างต้น แพลตฟอร์มมีสิทธิ์เพิกถอนหมายเลข และอาจจำกัดบัญชีเดิม เช่น ระงับ/ลดสิทธิ์",
    lang10:
      "3. ฉันยินยอมปฏิบัติตามข้อตกลงผู้ใช้และกฎหมายที่เกี่ยวข้อง และจะไม่ใช้หมายเลขนี้กระทำการฝ่าฝืนหรือผิดกฎหมาย",
    lang11:
      "เมื่อเซ็นแล้ว ข้อตกลงนี้มีผลผูกพันทันที ขอบคุณสำหรับความเข้าใจและความร่วมมือ",
    lang12: "ไม่ยอมรับ",
    lang13: "ยอมรับ",
    lang14: "ผู้ใช้ยอมรับแล้ว",
    lang15: "เวลา: ",
    lang16: "ส่งคำขอย้ายสำเร็จ",
    lang17:
      "ทีมบริการลูกค้าจะติดต่อคุณเพื่อแจ้งเวลาที่แน่นอน ขอบคุณสำหรับการสนับสนุน",
    lang18: "รับทราบ",
    lang19: "คุณได้ส่งคำขอเรียบร้อยแล้ว ขอบคุณสำหรับการสนับสนุน",
    lang20: "รีเฟรช",
    lang21: "บริการลูกค้า",
    lang22: "ปิดหน้า",
    lang23: "เพิ่มเติม",
  },
  vipUpPublicNotice: {
    lang1:
      "เพื่อมอบประสบการณ์ที่พิเศษและเฉพาะตัวมากยิ่งขึ้น เราจะเปิดตัวระบบระดับ VIP ใหม่ในวันที่ ",
    lang2: "2026/8/4",
    lang3: "เปิดตัวระดับสมาชิกใหม่สุดหรูอย่างเป็นทางการ",
    lang4:
      "การอัปเดตนี้ปรับแต้มความมั่งคั่งที่ต้องการสำหรับบางระดับ และเพิ่มสิทธิพิเศษที่หลากหลายขึ้น รายละเอียดดังนี้:",
    lang5: "หลังระบบใหม่ออนไลน์ ระดับเดิมของคุณจะ ",
    lang6: "สืบทอดโดยอัตโนมัติตามแต้มความมั่งคั่ง",
    lang7: " ไปยังระดับ VIP ที่สอดคล้อง",
    lang8:
      "เช่น เดิมคือ VIP43 แต้ม 3,254,120 จะสืบทอดเป็น VIP45 แต้มไม่เปลี่ยน และได้รับสิทธิ VIP ที่สอดคล้อง",
    lang9: "ประเภทสิทธิพิเศษ",
    lang10: "รายละเอียดสิทธิ",
    lang11: "ระดับปลดล็อก",
    lang12: "ซ่อนตัวตน",
    lang13: "โหมดล่องหน",
    lang14: "ยกเว้นการจัดการ",
    lang15: "ป้องกันเตะ/ปิดเสียง",
    lang16: "ยานพาหนะส่วนตัว",
    lang17: "ยานพาหนะเฉพาะสุดพิเศษ",
    lang18: "ระบบหมายเลขสวย",
    lang19: "หมายเลขสวย 6/5/4 หลัก",
    lang20: "สีข้อความ",
    lang21: "ปรับแต่ง 3/5 สี",
    lang22: "บริการพิเศษ",
    lang23: "ช่องบริการลูกค้าพิเศษ",
    lang24: "สิทธิการเติมเงิน",
    lang25: "ช่องเติมเงินพิเศษ",
    lang26: "ตกแต่งโปรไฟล์",
    lang27: "พื้นหลังโปรไฟล์แบบคงที่/เคลื่อนไหว",
    lang28: "ของขวัญสั่งทำ",
    lang29: "ของขวัญระดับกลาง (5 วินาที) / ระดับสูง (10 วินาที)",
    lang30: "ประกาศทั้งไซต์",
    lang31: "ประกาศเมื่อออนไลน์ทั้งไซต์",
    lang32: "ระหว่างการพัฒนาแพลตฟอร์ม เราจะ ",
    lang33: "พัฒนาสิทธิ VIP และประสบการณ์บริการอย่างต่อเนื่อง",
    lang34:
      " หากมีการเปลี่ยนแปลงกติกาหรือสิทธิ เราจะแจ้งให้ทราบทันที โปรดติดตาม",
    lang35: "Firefly สงวนสิทธิ์ในการตีความขั้นสุดท้าย",
  },
  // Ludo
  ludo: {
    clubPkRoom: "ห้อง PK ของ {club}",
    lang1: "เปิดห้อง",
    lang2: "เข้าร่วมด่วน",
    lang3: "ค่าเข้า",
    lang4: "กำลังรอ",
    lang5: "ขณะนี้ยังไม่มีห้อง Ludo PK",
    lang6: "โหมดการเล่น",
    lang7: "คลับเริ่มต้น",
    lang8: "คลาสสิก",
    lang9: "ไม่จำกัด",
    lang10: "สถิติ",
    lang11: "อันดับ",
    lang12: "น้ำค้างค่าเข้า",
    lang13: "ข้อมูลการเล่น",
    lang16: "จ่ายน้ำค้างค่าเข้าเพื่อเข้าร่วม Ludo PK",
    lang17: "จำนวนผู้เล่น",
    lang18: "รางวัลผู้ชนะ",
    lang19: "ชื่อเสียง",
    lang20: "ไอเทมของฉัน",
    lang21: "หมาก",
    lang22: "กระดาน",
    lang23: "เลือกไอเทมหมากที่คุณต้องการใช้ในเกม LUDO",
    lang24: "เลือกไอเทมกระดานสำหรับห้องคลับ PK ของคุณในเกม LUDO",
    lang25: "ป้ายเวลา",
    lang26: "เลือกแล้ว",
    lang27: "ค่าเริ่มต้น",
    lang28: "กรุณาเลือกไอเทม",
    lang31: "ใช้",
    lang32: "แตะเพื่อเลือกไอเทมที่จะใช้",
    lang33: "แตะเพื่อใช้ เกม LUDO ถัดไปจะใช้ไอเทมกระดานนี้",
    lang34: "แตะเพื่อใช้ เกม LUDO ถัดไปจะใช้ไอเทมหมากนี้",
    lang35: "กำลังใช้งานอยู่",
    lang36: "กรุณาเลือกไอเทมที่จะใช้",
    lang37: "ใช้งานสำเร็จ จะมีผลในเกม LUDO ถัดไป",
    lang38: "วัน",
    lang39: "ชั่วโมง",
    lang40: "นาที",
    lang42: "ขณะนี้ยังไม่มีบันทึก LUDO PK",
    lang43: "รายละเอียดเกม",
    lang45: "ค่าห้อง",
    lang46: "เวลา",
    lang47: "น้ำค้าง",
    lang49: "วันที่",
    lang50: "รวม",
    lang51: "รูปผู้เล่น",
    lang52: "อันดับ",
    lang53: "อันดับ 1",
    lang54: "อันดับ 2",
    lang55: "อันดับ 3",
    lang56: "อันดับ 4",
    lang57: "กำลังโหลด...",
    lang58: "บริการลูกค้า",
    lang59: "ชนะ",
    lang60: "แพ้",
    lang61: "เสมอ",
    lang62: "คำอธิบายการเล่น",
    lang63: "กติกาเกม",
    lang64: "จำนวนผู้เล่น",
    lang66: "การตัดสินแพ้ชนะ",
    lang68: "ชื่อเสียงคลับ",
    lang69: "เข้าร่วมเกม",
    lang70: "เข้าร่วมระหว่างเกม",
    lang72: "ขึ้นบิน",
    lang73: "หกสามครั้งติด",
    lang74: "เดินหมาก",
    lang75: "ซ้อนหมาก",
    lang76: "กินหมาก",
    lang77: "เขตปลอดภัย",
    lang78: "2-4 คน",
    lang79:
      "คลาสสิก: หมากของผู้เล่นต้องเริ่มจากจุดเริ่มต้น เดินครบหนึ่งรอบแล้วเข้าสู่เส้นชัย เมื่อหมากทั้งหมดถึงเส้นชัยจะถือว่าเกมจบ ผู้ที่จบได้เร็วกว่าได้อันดับสูงกว่า",
    lang80:
      "ตามโหมดการเล่น ผู้ที่เล่นจบก่อนจะได้อันดับสูงกว่า เช่น ผู้เล่นคนแรกที่จบเกมจะได้อันดับ 1 ของรอบนี้ และเรียงลำดับต่อไป",
    lang81: "หลังจบเกม คุณจะได้รับรางวัลน้ำค้างและชื่อเสียงตามอันดับของคุณ",
    lang82:
      "หากคุณชนะเกมในห้องคลับที่คุณเข้าร่วม จะได้รับชื่อเสียงในคลับนั้นเพิ่มตามอันดับของเกม",
    lang83: "ชำระค่าน้ำค้างค่าเข้าที่เจ้าของห้องกำหนดเพื่อเข้าร่วมเกม",
    lang84:
      "ในเกมที่เริ่มไปแล้ว ผู้เล่นสามารถชำระน้ำค้างค่าเข้าเพื่อเข้าร่วม Ludo PK ระหว่างเกมได้",
    lang85: "ต้องทอยลูกเต๋าได้หกก่อน หมากจึงจะออกจากฐานไปยังช่องเริ่มต้นได้",
    lang86:
      "หากทอยได้หกสะสมครบ 3 ครั้งในตาเดียว จะเกิดสามหกติด และผู้เล่นจะถูกข้ามตานั้น",
    lang87: "ผู้เล่นทอยลูกเต๋าเพื่อให้ได้แต้ม และเดินหมากไปตามจำนวนก้าวที่ได้",
    lang88:
      "หมากของผู้เล่นคนเดียวกันที่อยู่ช่องเดียวกันจะกลายเป็นหมากซ้อน เมื่อถูกกินจะถูกเตะกลับฐานทั้งหมด",
    lang89:
      "หากหมากหยุดที่ช่องซึ่งมีหมากของผู้เล่นอื่นอยู่ หมากของผู้เล่นอื่นทั้งหมดจะถูกเตะกลับฐาน และต้องออกบินใหม่ก่อนจึงจะเดินต่อได้",
    lang90:
      "หมากที่อยู่บนจุดเริ่มต้นหรือช่องที่มีโล่บนกระดานจะไม่ถูกกิน หมากของผู้เล่นต่างคนสามารถอยู่ร่วมกันในช่องเหล่านี้ได้",
    lang91:
      "ในแต่ละเกมจะมีการเก็บจำนวนน้ำค้างคงที่เป็นค่าห้อง โดยจำนวนค่าห้องจะกำหนดตามปริมาณน้ำค้างค่าเข้า และไม่เกี่ยวข้องกับจำนวนผู้เล่น เมื่อมีการสรุปรางวัลน้ำค้างหลังจบเกม ระบบจะหักค่าห้องโดยอัตโนมัติก่อน แล้วจึงมอบรางวัลน้ำค้างให้ผู้ชนะ",
    lang92: "เข้าร่วมเกม",
    lang93: "ค่าห้องเกม",
    lang94: "ชนะ",
    lang95: "ผู้เล่น",
    lang96: "น้ำค้างสรุปผล",
    lang97: "ค่ารอบ",
    lang98: "เงินตั้งต้น",
    lang99: "/เกม",
    lang100: "ผลงานของฉัน",
    lang101: "ผู้เล่นที่เข้าร่วม",
    lang102: "ประวัติ",
  },
  teenPatti: {
    recordTitle: "บันทึก",
    rankingTitle: "กระดานอันดับ",
    confirm: "ยืนยัน",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "ตั้งค่าการเล่น",
    maxBet: "เดิมพันน้ำค้างสูงสุด",
    maxPot: "เงินกองกลางสูงสุด",
    buyInDew: "น้ำค้างที่นำเข้า",
    mockJoinTip: "โหมดทดลอง: เลือกน้ำค้างตั้งต้น {ante} แล้ว ยังไม่ได้เชื่อมต่อการเข้าร่วม",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "ห้อง PK ของ {club}",
    // 三张牌规则页文案：暂沿用此前的英文回退内容，待补充本语言翻译。
    title: "How to play",
    hands: "Hands",
    play: "Rules",
    order: "Hands ranked from highest to lowest",
    players: "Players: 2–5",
    mode: "Game mode:",
    intro: "Teen Patti is a strategy game in which players compare three-card hands. Read your hand and your opponents’ Dew wagers, then call, raise or compare hands to compete for the Dew in the pot. Suits do not determine hand strength.",
    flow: "Game flow",
    ante: "น้ำค้างตั้งต้น",
    anteText: "At the start of each game, the fixed base Dew set by the host is automatically deducted from every player and added to the pot.",
    deal: "Dealing",
    dealText: "Each player receives 3 face-down cards. Only the player can view their own cards after choosing to look at them.",
    turn: "Turns",
    turnText: "Players act in order until only one player remains, the pot limit is reached or the round limit is reached.",
    actions: "Player actions",
    blind: "Blind",
    blindText: "Wager Dew without looking at your cards. Calls and raises cost 1× the current Dew wager.",
    seen: "Seen",
    seenText: "Continue playing after viewing your cards. Calls and raises cost twice the blind player’s Dew wager.",
    compare: "Compare hands",
    condition: "Availability",
    conditionText: "Players can request a comparison from the second round onwards.",
    cost: "Cost",
    costText: "Requesting a comparison costs twice the current single Dew wager.",
    compareResult: "Result",
    compareResultText: "The requester can privately compare with any active player. If both hands have exactly the same type and ranks, the requester loses. The losing player is eliminated from the game.",
    fold: "Fold",
    foldText: "Leave the current game. Dew already contributed to the pot is not refunded.",
    allIn: "All in",
    allInText: "If your balance cannot cover the minimum call, you can put your entire remaining balance into the pot. You cannot take any more actions that game, but your hand is kept until the final showdown.",
    settlement: "Settlement",
    end: "Round limit",
    endText: "Each game has a maximum number of rounds to keep play moving. Refer to the limit displayed in the room.",
    showdown: "Showdown",
    showdownText: "When the round limit is reached, or only two players remain and one requests a showdown, the system reveals the remaining hands for a final comparison.",
    reward: "Dew reward",
    rewardText: "The winner receives the entire pot after the platform’s fixed-percentage service fee or commission has been deducted.",
    hand1: "Three of a kind",
    desc1: "Three cards of the same rank, such as AAA or 222",
    hand2: "Straight flush",
    desc2: "Three consecutive cards of the same suit, such as 4–5–6 of spades",
    hand3: "Flush",
    desc3: "Three cards of the same suit that are not consecutive",
    hand4: "Straight",
    desc4: "Three consecutive cards of mixed suits, such as 5♥, 6♦, 7♠",
    hand5: "Pair",
    desc5: "Two cards of the same rank and a third card, such as 223",
    hand6: "High card",
    desc6: "A hand that does not form any of the combinations above",
    hand7: "235",
    desc7: "A mixed-suit 2, 3 and 5 beats three of a kind only when a three-of-a-kind hand is present at the table. Otherwise, 235 is treated as a high-card hand.",
    rankOrder: "Within a hand type, A is highest and 2 is lowest. AAA is the highest three of a kind; 222 is the lowest. For straights and straight flushes, A–K–Q is highest and 3–2–A is lowest.",
    sameHand: "For flushes and high-card hands, compare the highest card first, then the second and third cards if tied. Suits have no ranking.",
    samePair: "For pairs, compare the pair first, then the remaining card if tied.",
    lang1: "เปิดห้อง",
    lang2: "เข้าร่วมด่วน",
    lang3: "ค่าเข้า",
    lang4: "กำลังรอ",
    lang5: "ขณะนี้ยังไม่มีห้อง Teen Patti PK",
    lang6: "โหมดการเล่น",
    lang7: "คลับเริ่มต้น",
    lang8: "คลาสสิก",
    lang9: "ไม่จำกัด",
    lang10: "สถิติ",
    lang11: "อันดับ",
    lang12: "น้ำค้างค่าเข้า",
    lang13: "ข้อมูลการเล่น",
    lang16: "จ่ายน้ำค้างค่าเข้าเพื่อเข้าร่วม Ludo PK",
    lang17: "จำนวนผู้เล่น",
    lang18: "รางวัลผู้ชนะ",
    lang19: "ชื่อเสียง",
    lang20: "ไอเทมของฉัน",
    lang21: "หมาก",
    lang22: "กระดาน",
    lang23: "เลือกไอเทมหมากที่คุณต้องการใช้ในเกม LUDO",
    lang24: "เลือกไอเทมกระดานสำหรับห้องคลับ PK ของคุณในเกม LUDO",
    lang25: "ป้ายเวลา",
    lang26: "เลือกแล้ว",
    lang27: "ค่าเริ่มต้น",
    lang28: "กรุณาเลือกไอเทม",
    lang31: "ใช้",
    lang32: "แตะเพื่อเลือกไอเทมที่จะใช้",
    lang33: "แตะเพื่อใช้ เกม LUDO ถัดไปจะใช้ไอเทมกระดานนี้",
    lang34: "แตะเพื่อใช้ เกม LUDO ถัดไปจะใช้ไอเทมหมากนี้",
    lang35: "กำลังใช้งานอยู่",
    lang36: "กรุณาเลือกไอเทมที่จะใช้",
    lang37: "ใช้งานสำเร็จ จะมีผลในเกม LUDO ถัดไป",
    lang38: "วัน",
    lang39: "ชั่วโมง",
    lang40: "นาที",
    lang42: "ขณะนี้ยังไม่มีบันทึก Teenpatti PK",
    lang43: "รายละเอียดเกม",
    lang45: "ค่าห้อง",
    lang46: "เวลา",
    lang47: "น้ำค้าง",
    lang49: "วันที่",
    lang50: "รวม",
    lang51: "รูปผู้เล่น",
    lang52: "อันดับ",
    lang53: "อันดับ 1",
    lang54: "อันดับ 2",
    lang55: "อันดับ 3",
    lang56: "อันดับ 4",
    lang57: "กำลังโหลด...",
    lang58: "บริการลูกค้า",
    lang59: "ชนะ",
    lang60: "แพ้",
    lang61: "เสมอ",
    lang62: "คำอธิบายการเล่น",
    lang63: "กติกาเกม",
    lang64: "จำนวนผู้เล่น",
    lang66: "การตัดสินแพ้ชนะ",
    lang68: "ชื่อเสียงคลับ",
    lang69: "เข้าร่วมเกม",
    lang70: "เข้าร่วมระหว่างเกม",
    lang72: "ขึ้นบิน",
    lang73: "หกสามครั้งติด",
    lang74: "เดินหมาก",
    lang75: "ซ้อนหมาก",
    lang76: "กินหมาก",
    lang77: "เขตปลอดภัย",
    lang78: "2-4 คน",
    lang79:
      "คลาสสิก: หมากของผู้เล่นต้องเริ่มจากจุดเริ่มต้น เดินครบหนึ่งรอบแล้วเข้าสู่เส้นชัย เมื่อหมากทั้งหมดถึงเส้นชัยจะถือว่าเกมจบ ผู้ที่จบได้เร็วกว่าได้อันดับสูงกว่า",
    lang80:
      "ตามโหมดการเล่น ผู้ที่เล่นจบก่อนจะได้อันดับสูงกว่า เช่น ผู้เล่นคนแรกที่จบเกมจะได้อันดับ 1 ของรอบนี้ และเรียงลำดับต่อไป",
    lang81: "หลังจบเกม คุณจะได้รับรางวัลน้ำค้างและชื่อเสียงตามอันดับของคุณ",
    lang82:
      "หากคุณชนะเกมในห้องคลับที่คุณเข้าร่วม จะได้รับชื่อเสียงในคลับนั้นเพิ่มตามอันดับของเกม",
    lang83: "ชำระค่าน้ำค้างค่าเข้าที่เจ้าของห้องกำหนดเพื่อเข้าร่วมเกม",
    lang84:
      "ในเกมที่เริ่มไปแล้ว ผู้เล่นสามารถชำระน้ำค้างค่าเข้าเพื่อเข้าร่วม Ludo PK ระหว่างเกมได้",
    lang85: "ต้องทอยลูกเต๋าได้หกก่อน หมากจึงจะออกจากฐานไปยังช่องเริ่มต้นได้",
    lang86:
      "หากทอยได้หกสะสมครบ 3 ครั้งในตาเดียว จะเกิดสามหกติด และผู้เล่นจะถูกข้ามตานั้น",
    lang87: "ผู้เล่นทอยลูกเต๋าเพื่อให้ได้แต้ม และเดินหมากไปตามจำนวนก้าวที่ได้",
    lang88:
      "หมากของผู้เล่นคนเดียวกันที่อยู่ช่องเดียวกันจะกลายเป็นหมากซ้อน เมื่อถูกกินจะถูกเตะกลับฐานทั้งหมด",
    lang89:
      "หากหมากหยุดที่ช่องซึ่งมีหมากของผู้เล่นอื่นอยู่ หมากของผู้เล่นอื่นทั้งหมดจะถูกเตะกลับฐาน และต้องออกบินใหม่ก่อนจึงจะเดินต่อได้",
    lang90:
      "หมากที่อยู่บนจุดเริ่มต้นหรือช่องที่มีโล่บนกระดานจะไม่ถูกกิน หมากของผู้เล่นต่างคนสามารถอยู่ร่วมกันในช่องเหล่านี้ได้",
    lang91:
      "ในแต่ละเกมจะมีการเก็บจำนวนน้ำค้างคงที่เป็นค่าห้อง โดยจำนวนค่าห้องจะกำหนดตามปริมาณน้ำค้างค่าเข้า และไม่เกี่ยวข้องกับจำนวนผู้เล่น เมื่อมีการสรุปรางวัลน้ำค้างหลังจบเกม ระบบจะหักค่าห้องโดยอัตโนมัติก่อน แล้วจึงมอบรางวัลน้ำค้างให้ผู้ชนะ",
    lang92: "เข้าร่วมเกม",
    lang93: "ค่าห้องเกม",
    lang94: "ชนะ",
    lang95: "ผู้เล่น",
    lang96: "น้ำค้างสรุปผล",
    lang97: "ค่ารอบ",
    lang98: "น้ำค้างตั้งต้น",
  },
};
